import { defineStore, storeToRefs } from 'pinia'


export interface serverSeoList {
    arSetting: string
    cnSetting: string
    deSetting: string
    enSetting: string
    frSetting: string
    hibSetting: string
    idSetting: string
    itbSetting: string
    jaSetting: string
    koSetting: string
    twSetting: string
    ukSetting: string
    pathUrl: string
    name: string
    id: number
}

export interface seoList {
    arSetting: seoConfig
    cnSetting: seoConfig
    deSetting: seoConfig
    enSetting: seoConfig
    frSetting: seoConfig
    hibSetting: seoConfig
    idSetting: seoConfig
    itbSetting: seoConfig
    jaSetting: seoConfig
    koSetting: seoConfig
    twSetting: seoConfig
    ukSetting: seoConfig
    pathUrl: string
    name: string
    altJsonArray: Record<string, string>[]
}

export interface seoConfig {
    description: string;
    title: string;
    h1: string;
}

const useSeoStore = defineStore('seo', ()=>{

    let seoConfig = ref({})
    let altConfig = ref({})
    let seoH1 = ref('')
    function setSeoH1(h1: string){
        seoH1.value = h1
    }

    function setSeoConfig(routerConfigs: Array<serverSeoList>){
        // console.log('setSeoConfig==', routerConfigs)
        let newConfig = {}
        let alts = {}
        routerConfigs.forEach((config)=>{
            const seo: Partial<seoList> = {};
            seo.arSetting = JSON.parse(config.arSetting)
            seo.cnSetting = JSON.parse(config.cnSetting)
            seo.deSetting = JSON.parse(config.deSetting)
            seo.enSetting = JSON.parse(config.enSetting)
            seo.frSetting = JSON.parse(config.frSetting)
            seo.hibSetting = JSON.parse(config.hibSetting)
            seo.idSetting = JSON.parse(config.idSetting)
            seo.itbSetting = JSON.parse(config.itbSetting)
            seo.jaSetting = JSON.parse(config.jaSetting)
            seo.koSetting = JSON.parse(config.koSetting)
            seo.twSetting = JSON.parse(config.twSetting)
            seo.ukSetting = JSON.parse(config.ukSetting)
            seo.altJsonArray = config.altJsonArray ? JSON.parse(config.altJsonArray) : []
            seo.pathUrl = config.pathUrl
            seo.name = config.name

            newConfig[config.pathUrl] = {
                zh: seo.cnSetting, 
                en: seo.enSetting, 
                ja: seo.jaSetting, 
                ko: seo.koSetting, 
                tw: seo.twSetting, 
                uk: seo.ukSetting,
                ar: seo.arSetting,
                de: seo.deSetting,
                fr: seo.frSetting,
                id: seo.idSetting,
                itb: seo.itbSetting,
                hi: seo.hibSetting,
            }
            let srcAlt = {}
            seo.altJsonArray?.forEach((item)=>{
                let fristKey = Object.keys(item)[0]
                srcAlt[fristKey] = item[fristKey]
                // alts[config.pathUrl] = item
            })
            alts[config.pathUrl] = srcAlt
        })
        seoConfig.value = newConfig
        altConfig.value = alts

        // console.log('altConfig=====>>', altConfig.value)
    }   

    return {
        seoConfig,
        setSeoConfig,
        seoH1,
        setSeoH1,
        altConfig
    }
})

export default useSeoStore
